/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Attach: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.89595 3.94921C12.4361 1.35026 16.5641 1.35026 19.1043 3.94921C21.6319 6.53537 21.6319 10.7191 19.1043 13.3053L11.9744 20.6002C10.1502 22.4666 7.18295 22.4666 5.35877 20.6002C3.54708 18.7465 3.54708 15.7505 5.35877 13.8968L12.4886 6.60191C13.5969 5.46801 15.4034 5.46801 16.5116 6.60191C17.6073 7.72303 17.6073 9.53144 16.5116 10.6526L9.38175 17.9475C8.99572 18.3424 8.36259 18.3497 7.96763 17.9637C7.57266 17.5776 7.56541 16.9445 7.95144 16.5495L15.0813 9.25461C15.4174 8.91068 15.4174 8.34378 15.0813 7.99985C14.7576 7.6687 14.2426 7.6687 13.9189 7.99985L6.78907 15.2948C5.73698 16.3712 5.73698 18.1258 6.78907 19.2022C7.82867 20.2659 9.50451 20.2659 10.5441 19.2022L17.674 11.9073C19.442 10.0983 19.442 7.15613 17.674 5.34715C15.9184 3.55095 13.0818 3.55095 11.3263 5.34715L10.354 6.34191C9.96797 6.73688 9.33485 6.74412 8.93988 6.35809C8.54491 5.97206 8.53766 5.33894 8.92369 4.94397L9.89595 3.94921Z'
      fill='currentColor'
    />
  </React.Fragment>
)
